import * as React from 'react';

interface IContentProps {
	type?: 'full' | 'mid' | 'narrow' | 'tile';
	className?: string;
	allowOverflow?: boolean;
	children?: React.ReactNode;
}

export const Content: React.FC<IContentProps> = ({ type, className, allowOverflow, children }) => {
	const classes = ['page__content', `page__content--${type || 'narrow'}`, `${className || ''}`];
	if (allowOverflow) {
		classes.push('page__content--allow-overflow');
	}
	return <div className={classes.join(' ')}>{children}</div>;
};
